module.exports = __webpack_public_path__ + "images/408.gif";